module.exports = __webpack_public_path__ + "static/quiz_thumbnail_3-9b97abea7367c817365b0f4e844d6e4b.jpg";